export default "__VITE_ASSET__C4Le870F__"